import * as $runtime from "../runtime.js";
import * as Data$dArray$dNonEmpty$dSerialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dSet$dSerialized from "../Data.Set.Serialized/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dColor from "../Restaumatic.Menu.V2.Types.Color/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dUIElement from "../Restaumatic.Menu.V2.Types.UIElement/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $MenuSectionItem = (tag, _1) => ({tag, _1});
const $SectionContent = (tag, _1) => ({tag, _1});
const SingleProduct = value0 => $MenuSectionItem("SingleProduct", value0);
const ProductCombo = value0 => $MenuSectionItem("ProductCombo", value0);
const ProductCreator = value0 => $MenuSectionItem("ProductCreator", value0);
const UIElement = value0 => $MenuSectionItem("UIElement", value0);
const Products = value0 => $SectionContent("Products", value0);
const MostPopular = value0 => $SectionContent("MostPopular", value0);
const GenericFormula = /* #__PURE__ */ $SectionContent("GenericFormula");
const ArbitraryHtml = value0 => $SectionContent("ArbitraryHtml", value0);
const MenuSection = x => x;
const newtypeMenuSection_ = {Coercible0: () => {}};
const hasFieldMenuSection = dictHasField => dictHasField;
const eqMenuSectionItem = {
  eq: x => y => {
    if (x.tag === "SingleProduct") {
      if (y.tag === "SingleProduct") {
        return Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq(x._1.customParameterValues)(y._1.customParameterValues) && x._1.itemProduct === y._1.itemProduct;
      }
      return false;
    }
    if (x.tag === "ProductCombo") {
      if (y.tag === "ProductCombo") { return x._1.combo === y._1.combo; }
      return false;
    }
    if (x.tag === "ProductCreator") {
      if (y.tag === "ProductCreator") {
        return Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x._1.creatorDescription)(y._1.creatorDescription) && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x._1.creatorName)(y._1.creatorName) && (() => {
          if (x._1.creatorPhoto.tag === "Nothing") { return y._1.creatorPhoto.tag === "Nothing"; }
          if (x._1.creatorPhoto.tag === "Just") {
            if (y._1.creatorPhoto.tag === "Just") { return x._1.creatorPhoto._1 === y._1.creatorPhoto._1; }
            return false;
          }
          return false;
        })() && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x._1.creatorProducts)(y._1.creatorProducts);
      }
      return false;
    }
    if (x.tag === "UIElement") {
      if (y.tag === "UIElement") {
        if (x._1.uiElement.tag === "Divider") { return y._1.uiElement.tag === "Divider"; }
        if (x._1.uiElement.tag === "Picture") {
          if (y._1.uiElement.tag === "Picture") { return x._1.uiElement._1 === y._1.uiElement._1; }
          return false;
        }
        if (x._1.uiElement.tag === "CustomHtml") {
          if (y._1.uiElement.tag === "CustomHtml") { return x._1.uiElement._1 === y._1.uiElement._1; }
          return false;
        }
        return false;
      }
      return false;
    }
    return false;
  }
};
const eqSectionContent = {
  eq: x => y => {
    if (x.tag === "Products") {
      if (y.tag === "Products") { return Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqMenuSectionItem).eq(x._1.items)(y._1.items); }
      return false;
    }
    if (x.tag === "MostPopular") {
      if (y.tag === "MostPopular") { return x._1.howMany === y._1.howMany; }
      return false;
    }
    if (x.tag === "GenericFormula") { return y.tag === "GenericFormula"; }
    if (x.tag === "ArbitraryHtml") {
      if (y.tag === "ArbitraryHtml") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const eqMenuSection = {
  eq: x => y => (() => {
    if (x.color.tag === "Nothing") { return y.color.tag === "Nothing"; }
    if (x.color.tag === "Just") {
      if (y.color.tag === "Just") { return x.color._1 === y.color._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.columnParameter.tag === "Nothing") { return y.columnParameter.tag === "Nothing"; }
    if (x.columnParameter.tag === "Just") {
      if (y.columnParameter.tag === "Just") { return x.columnParameter._1 === y.columnParameter._1; }
      return false;
    }
    return false;
  })() && eqSectionContent.eq(x.content)(y.content) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Data$dEq.eqString).eq(x.customParameterValues)(y.customParameterValues) && (() => {
    if (x.defaultCategory.tag === "Nothing") { return y.defaultCategory.tag === "Nothing"; }
    if (x.defaultCategory.tag === "Just") {
      if (y.defaultCategory.tag === "Just") { return x.defaultCategory._1 === y.defaultCategory._1; }
      return false;
    }
    return false;
  })() && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.description)(y.description) && Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.dropdownParameters)(y.dropdownParameters) && Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString).eq(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.visibilitySchedule.tag === "Nothing") { return y.visibilitySchedule.tag === "Nothing"; }
    if (x.visibilitySchedule.tag === "Just") {
      if (y.visibilitySchedule.tag === "Just") { return x.visibilitySchedule._1 === y.visibilitySchedule._1; }
      return false;
    }
    return false;
  })() && x.visible === y.visible && Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.eqMenuConsumer)(Data$dEq.eqUnit).eq(x.visibleIn)(y.visibleIn)
};
const genericSectionContent = {
  to: x => {
    if (x.tag === "Inl") { return $SectionContent("Products", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $SectionContent("MostPopular", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return GenericFormula; }
        if (x._1._1.tag === "Inr") { return $SectionContent("ArbitraryHtml", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Products") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "MostPopular") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "GenericFormula") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "ArbitraryHtml") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const genericMenuSectionItem = {
  to: x => {
    if (x.tag === "Inl") { return $MenuSectionItem("SingleProduct", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $MenuSectionItem("ProductCombo", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $MenuSectionItem("ProductCreator", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $MenuSectionItem("UIElement", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "SingleProduct") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "ProductCombo") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ProductCreator") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "UIElement") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const showMenuSectionItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["customParameterValues", $0.show(v.customParameterValues)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "itemProduct",
              v.itemProduct
            ]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "SingleProduct"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["combo", v.combo]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ProductCombo"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $2 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $3 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["creatorDescription", $3.show(v.creatorDescription)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "creatorName",
              $2.show(v.creatorName)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "creatorPhoto",
              (() => {
                if (v.creatorPhoto.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v.creatorPhoto._1) + ")"; }
                if (v.creatorPhoto.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["creatorProducts", "(NonEmptyArray " + Data$dShow.showArrayImpl(Data$dUUID.toString)(v.creatorProducts) + ")"]))([]))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "ProductCreator"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["uiElement", Restaumatic$dMenu$dV2$dTypes$dUIElement.showUIElement.show(v.uiElement)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "UIElement"});
    return x => {
      const $4 = genericMenuSectionItem.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showSectionContent = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showMenuSectionItem);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0.show(v.items)]))([]);
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "Products"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["howMany", Data$dShow.showIntImpl(v.howMany)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "MostPopular"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "GenericFormula"});
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "ArbitraryHtml"});
    return x => {
      const $4 = genericSectionContent.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeMenuSectionItem = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "SingleProduct"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "customParameterValues"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
        reflectSymbol: () => "itemProduct"
      })(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ProductCombo"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "combo"})(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ProductCreator"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "creatorDescription"})(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
        reflectSymbol: () => "creatorName"
      })(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
        reflectSymbol: () => "creatorPhoto"
      })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto))(Unscramble.decodeRecordCons({reflectSymbol: () => "creatorProducts"})(Unscramble.decodeNonEmptyArray(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "UIElement"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "uiElement"})(Restaumatic$dMenu$dV2$dTypes$dUIElement.unscrambleDecodeUIElement)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    })))))(Unscramble$dGeneric.defaultOptions);
    return x => genericMenuSectionItem.to($0(x));
  })()
};
const unscrambleDecodeSectionContent = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({
      reflectSymbol: () => "Products"
    })({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeMenuSectionItem)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "MostPopular"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "howMany"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)({
      reflectSymbol: () => "GenericFormula"
    }))(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "ArbitraryHtml"})({unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeString(x.contents)})))))(Unscramble$dGeneric.defaultOptions);
    return x => genericSectionContent.to($0(x));
  })()
};
const genericMenuSection = {to: x => x, from: x => x};
const showMenuSection = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dSet.showSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.showMenuConsumer);
      const $1 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $2 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      const $3 = Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
      const $4 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Data$dUUID.showUUID);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")([
              "color",
              (() => {
                if (v.color.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dColor.showColor.show(v.color._1) + ")"; }
                if (v.color.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "columnParameter",
              (() => {
                if (v.columnParameter.tag === "Just") { return "(Just " + v.columnParameter._1 + ")"; }
                if (v.columnParameter.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["content", showSectionContent.show(v.content)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "customParameterValues",
              $4.show(v.customParameterValues)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "defaultCategory",
              (() => {
                if (v.defaultCategory.tag === "Just") { return "(Just " + v.defaultCategory._1 + ")"; }
                if (v.defaultCategory.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["description", $3.show(v.description)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "dropdownParameters",
              $2(v.dropdownParameters)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["name", $1.show(v.name)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "photo",
              (() => {
                if (v.photo.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v.photo._1) + ")"; }
                if (v.photo.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "visibilitySchedule",
              (() => {
                if (v.visibilitySchedule.tag === "Just") { return "(Just " + v.visibilitySchedule._1 + ")"; }
                if (v.visibilitySchedule.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["visible", v.visible ? "true" : "false"]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "visibleIn",
              $0.show(v.visibleIn)
            ]))([]))))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "MenuSection"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenuSection = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "color"})(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dColor.unscrambleDecodeColor))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "columnParameter"
    })(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({reflectSymbol: () => "content"})(unscrambleDecodeSectionContent)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "customParameterValues"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({reflectSymbol: () => "defaultCategory"})(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "description"
    })(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "dropdownParameters"
    })({unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)})(Unscramble.decodeRecordCons({reflectSymbol: () => "name"})(Unscramble.decodeMap(Restaumatic$dLocales.ufromJSONKeyLocale)(Restaumatic$dLocales.ordLocale)(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "photo"
    })(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto))(Unscramble.decodeRecordCons({reflectSymbol: () => "visibilitySchedule"})(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "visible"
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({reflectSymbol: () => "visibleIn"})(Unscramble.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.unscrambleDecodeMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer))(Unscramble.decodeRecordNil)))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeMenuSectionItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuSectionItem)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "SingleProduct"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "itemProduct"})({
        encodeWithOptions: v => Data$dUUID.encodeUUID.encode
      }))({reflectSymbol: () => "customParameterValues"})((() => {
        const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
        });
        return {encodeWithOptions: v => $0.encode};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductCombo"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "combo"})({
        encodeWithOptions: v => Data$dUUID.encodeUUID.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ProductCreator"})((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
        reflectSymbol: () => "creatorProducts"
      })((() => {
        const $2 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
        return {encodeWithOptions: v => $2};
      })()))({reflectSymbol: () => "creatorPhoto"})({
        encodeWithOptions: v => v2 => {
          if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
          if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPhoto.encodePhoto.encode(v2._1); }
          $runtime.fail();
        }
      }))({reflectSymbol: () => "creatorName"})((() => {
        const $2 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
        return {encodeWithOptions: v => $2.encode};
      })()))({reflectSymbol: () => "creatorDescription"})((() => {
        const $2 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
        return {encodeWithOptions: v => $2.encode};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "UIElement"})((() => {
      const $3 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "uiElement"})({
        encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dUIElement.encodeUIElement.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $3.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              return $3.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeSectionContent = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSectionContent)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Products"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "items"})((() => {
        const $0 = Data$dMap$dOrdered.encodeMap(Data$dTuple$dT2.encodeT2({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
        })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeMenuSectionItem.encode(v)), Data$dList$dTypes.Nil)}));
        return {encodeWithOptions: v => $0.encode};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "MostPopular"})((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "howMany"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "GenericFormula"})(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "ArbitraryHtml"})({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    return {
      encodeOpts: opts => v => {
        if (v.tag === "Inl") {
          return $0.encodeOpts({
            sumEncoding: opts.sumEncoding,
            unwrapSingleConstructors: false,
            unwrapSingleArguments: opts.unwrapSingleArguments,
            unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
            fieldTransform: opts.fieldTransform
          })(v._1);
        }
        if (v.tag === "Inr") {
          if (v._1.tag === "Inl") {
            return $1.encodeOpts({
              sumEncoding: opts.sumEncoding,
              unwrapSingleConstructors: false,
              unwrapSingleArguments: opts.unwrapSingleArguments,
              unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
              fieldTransform: opts.fieldTransform
            })(v._1._1);
          }
          if (v._1.tag === "Inr") {
            if (v._1._1.tag === "Inl") {
              return $2.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            if (v._1._1.tag === "Inr") {
              return $3.encodeOpts({
                sumEncoding: opts.sumEncoding,
                unwrapSingleConstructors: false,
                unwrapSingleArguments: opts.unwrapSingleArguments,
                unwrapSingleRecordArguments: opts.unwrapSingleRecordArguments,
                fieldTransform: opts.fieldTransform
              })(v._1._1._1);
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeMenuSection = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "MenuSection"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "visibleIn"
    })((() => {
      const $0 = Data$dSet$dSerialized.encodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.encodeMenuConsumer);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "visible"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "visibilitySchedule"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "photo"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPhoto.encodePhoto.encode(v2._1); }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "name"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "dropdownParameters"})((() => {
      const $0 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "description"})((() => {
      const $0 = Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "defaultCategory"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "customParameterValues"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.encodeUUID)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "content"})({encodeWithOptions: v => encodeSectionContent.encode}))({reflectSymbol: () => "columnParameter"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "color"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dColor.encodeColor.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeMenuSectionItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuSectionItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "SingleProduct"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "itemProduct"
  })({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())({reflectSymbol: () => "customParameterValues"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductCombo"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "combo"
  })({decodeWithOptions: v => Data$dUUID.decodeUUID.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ProductCreator"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "creatorProducts"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dArray$dNonEmpty$dSerialized.decodeNonEmptyArray(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "creatorPhoto"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)})())({
    reflectSymbol: () => "creatorName"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "creatorDescription"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "UIElement"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "uiElement"
  })({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dUIElement.decodeUIElement.decode})())))(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
const decodeSectionContent = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSectionContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "Products"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "items"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeMenuSectionItem.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(Data$dOrd.ordString);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "MostPopular"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "howMany"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GenericFormula"
  })(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ArbitraryHtml"
  })({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))))
};
const decodeMenuSection = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "MenuSection"})(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "visibleIn"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dSet$dSerialized.decodeSet(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.ordMenuConsumer)(Restaumatic$dMenu$dV2$dTypes$dMenuConsumer.decodeMenuConsumer);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "visible"})({decodeWithOptions: v => Foreign.readBoolean(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "visibilitySchedule"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())({reflectSymbol: () => "photo"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)})())({
    reflectSymbol: () => "name"
  })(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "dropdownParameters"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "description"})(/* #__PURE__ */ (() => {
    const $0 = Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "defaultCategory"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)})())({
    reflectSymbol: () => "customParameterValues"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Data$dUUID.decodeUUID)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "content"})({decodeWithOptions: v => decodeSectionContent.decode})())({reflectSymbol: () => "columnParameter"})({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)
  })())({reflectSymbol: () => "color"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dColor.decodeColor.decode)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $MenuSectionItem,
  $SectionContent,
  ArbitraryHtml,
  GenericFormula,
  MenuSection,
  MostPopular,
  ProductCombo,
  ProductCreator,
  Products,
  SingleProduct,
  UIElement,
  decodeMenuSection,
  decodeMenuSectionItem,
  decodeSectionContent,
  encodeMenuSection,
  encodeMenuSectionItem,
  encodeSectionContent,
  eqMenuSection,
  eqMenuSectionItem,
  eqSectionContent,
  genericMenuSection,
  genericMenuSectionItem,
  genericSectionContent,
  hasFieldMenuSection,
  newtypeMenuSection_,
  showMenuSection,
  showMenuSectionItem,
  showSectionContent,
  unscrambleDecodeMenuSection,
  unscrambleDecodeMenuSectionItem,
  unscrambleDecodeSectionContent
};
